export default __webpack_public_path__ + "5bbe5fb1a9218c3ff78304dfc949bfa0.woff";